<template>
  <div class="vragenlijst-component">
    <div class="w-100 h-100">
      <TopBar @close="close = true" />

      <v-dialog v-model="close" max-width="724">
        <CloseDialog @back="close = false" />
      </v-dialog>

      <v-row no-gutters class="h-100">
        <v-col cols="12" md="10" lg="8" class="order-2 order-md-1">
          <div class="d-flex justify-center w-100 h-100 pa-4 pa-md-0">
            <div class="vragenlijst-holder d-flex flex-column ga-6 justify-center align-center"
              :class="step != 0 ? 'vragenlijst-margin' : ''">
              <v-window v-model="step" direction="vertical" :touch="{ left: false, right: false }">
                <v-window-item>
                  <StartStep ref="step0" :questions="questions" @update-questions="updateQuestions"></StartStep>
                </v-window-item>

                <v-window-item>
                  <IntakeStep ref="step1" :questions="questions" @update-questions="updateQuestions"></IntakeStep>
                </v-window-item>

                <v-window-item>
                  <PersoonlijkeGegevensStep ref="step2" :questions="questions" @update-questions="updateQuestions">
                  </PersoonlijkeGegevensStep>
                </v-window-item>

                <v-window-item>
                  <BezighedenStep ref="step3" :questions="questions" @update-questions="updateQuestions">
                  </BezighedenStep>
                </v-window-item>

                <v-window-item>
                  <BewegingStep ref="step4" :questions="questions" @update-questions="(updatedQuestions) => {
                    questions = updatedQuestions;
                  }
                    " />
                </v-window-item>

                <v-window-item>
                  <DoelStep ref="step5" :questions="questions" @update-questions="updateQuestions"></DoelStep>
                </v-window-item>

                <v-window-item>
                  <MaaltijdStep ref="step6" :questions="questions" @update-questions="updateQuestions"></MaaltijdStep>
                </v-window-item>

                <v-window-item>
                  <VoorkeurenStep ref="step7" :questions="questions" @update-questions="updateQuestions">
                  </VoorkeurenStep>
                </v-window-item>

                <v-window-item>
                  <EndStep ref="step8" :questions="questions" @update-questions="updateQuestions"></EndStep>
                </v-window-item>
              </v-window>

              <div class="w-100 d-flex align-center ga-4" :class="isStartOrEndStep ? 'justify-start' : 'justify-end'">
                <v-btn v-if="step == 0" size="large" rounded flat color="secondary" @click="nextStep">
                  Aan de slag
                </v-btn>

                <v-btn v-if="!isStartOrEndStep" flat icon color="light" @click="previousStep">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 19L5 12M5 12L12 5M5 12H19" stroke="#E26D6D" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </v-btn>

                <v-btn v-if="!isStartOrEndStep" size="large" rounded flat :loading="loading" color="secondary"
                  @click="nextStep">
                  Volgende
                </v-btn>

                <v-btn v-if="step == max_step" size="large" rounded flat color="secondary" @click="close_form">
                  Afsluiten
                </v-btn>
              </div>
            </div>
          </div>
          <ProgressBar :steps="max_step" :current-step="step" />
        </v-col>

        <v-col :cols="step == 0 ? 12 : 0" md="2" lg="4" class="order-1 order-md-2 vragenlijst-image"
          :class="currentImageClass">
          <!-- <v-img cover :src="currentImage" /> -->
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import TopBar from "./top-bar/top-bar.vue";
import CloseDialog from "./dialogs/close-dialog.vue";

import StartStep from "./steps/start-step.vue";
import IntakeStep from "./steps/intake-step.vue";
import PersoonlijkeGegevensStep from "./steps/persoonlijke-gegevens-step.vue";
import BezighedenStep from "./steps/bezigheden-step.vue";
import BewegingStep from "./steps/beweging-step.vue";
import DoelStep from "./steps/doel-step.vue";
import MaaltijdStep from "./steps/maaltijd-step.vue";
import VoorkeurenStep from "./steps/voorkeuren-step.vue";
import EndStep from "./steps/end-step.vue";

import ProgressBar from "./sliders/progress-bar.vue";

import api from "../services/api";

export default {
  components: {
    TopBar,
    CloseDialog,

    StartStep,
    IntakeStep,
    PersoonlijkeGegevensStep,
    BezighedenStep,
    BewegingStep,
    DoelStep,
    MaaltijdStep,
    VoorkeurenStep,
    EndStep,

    ProgressBar,
  },
  data() {
    return {
      step: 0,
      questions: {}, // This is the reactive object
      max_step: 8,
      loading: false,

      close: false,
    };
  },
  computed: {
    isStartOrEndStep() {
      return this.step === 0 || this.step === this.max_step;
    },
    currentImageClass() {
      if (this.step === this.max_step) return "vragenlijst-image-end";
      return "vragenlijst-image-start";
    },
  },
  methods: {
    async sendQuestions() {
      const currentWindowItem = this.$refs[`step${this.step}`]; // Get the current step component
      if (currentWindowItem) {
        const formRef = currentWindowItem.$refs[`form${this.step}`]; // Get the form ref inside the current step component
        if (formRef) {
          const { valid } = await formRef.validate(); // Validate the form
          if (valid) {
            let urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has("order")) {
              const param = urlParams.get("order");
              this.loading = true;
              try {
                const res = await api.patch(
                  `v1/orders/${param}/questions`,
                  this.questions
                );
                if (res.data.success) {
                  this.step++;
                }
              } catch (error) {
                console.error(error);
                this.$toast.error(
                  "Fout bij het opslaan van de vragenlijst. Controleer alle velden."
                );
              }
            } else {
              this.$toast.error("De link is ongeldig");
              this.step++;
            }
          } else {
            console.error("Validation failed in sendQuestions.");
          }
        } else {
          console.error(
            `Form reference "form${this.step}" not found in step ${this.step}.`
          );
        }
      } else {
        console.error(`Step reference "step${this.step}" not found.`);
      }
    },

    async nextStep() {
      const currentWindowItem = this.$refs[`step${this.step}`]; // Get the current step component
      if (currentWindowItem) {
        const formRef = currentWindowItem.$refs[`form${this.step}`]; // Get the form ref inside the current step component
        if (formRef) {
          try {
            const { valid } = await formRef.validate(); // Wait for the validation result
            console.log("Validation result:", valid);
            if (valid) {
              if (this.step + 1 === this.max_step) {
                this.sendQuestions(); // Call sendQuestions method on the last step
              } else {
                this.step++; // Proceed to the next step
                window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to the top
              }
            }
          } catch (error) {
            console.error("Validation error:", error);
          }
        } else {
          console.error(
            `Form reference "form${this.step}" not found in step ${this.step}.`
          );
        }
      } else {
        console.error(`Step reference "step${this.step}" not found.`);
      }
    },

    close_form() {
      window.location.replace("https://app.getfitonline.nl");
    },

    previousStep() {
      this.step--;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    updateQuestions(updatedQuestions) {
      this.questions = { ...this.questions, ...updatedQuestions };
    },
  },
};
</script>
